import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/alertMessageBox.scss';
import { Spacing } from '@front/sharedcomponents/Variables';
import { Resources } from '@shared/localizations/Resources';
import { getAlertIconColor } from './AlertMessageBox.utils';
import { Button } from '../../elements/Button/Button';
import { ButtonType } from '../../elements/Button/ButtonType';
import { Label } from '../../elements/Label/Label';
import { Stack } from '@front/sharedcomponents/Stack/Stack';
import { SvgIcon } from '../../elements/SvgIcon/SvgIcon';
import { SvgIconType } from '../../elements/SvgIcon/SvgIconType';
import { TypographyLevel } from '../../elements/Typography/TypographyLevel';
export const AlertMessageBox = ({ message, type, onClose }) => {
    return (_jsxs(Stack, { className: "alert-message-box", direction: "column", spacing: Spacing.Xl, children: [_jsxs(Stack, { className: "alert-message-box-content", children: [_jsx(SvgIcon, { className: getAlertIconColor(type), icon: SvgIconType.Alerts }), _jsx(Label, { level: TypographyLevel.Paragraph, children: message })] }), _jsx(Stack, { className: "alert-message-box-footer", justify: "flex-end", children: _jsx(Button, { type: ButtonType.Primary, onClick: () => onClose(), text: Resources.getResource('general.messageBox.ok') }) })] }));
};
